import { useEffect, useState } from 'react';
import { useDebounce } from '../hooks/useDebounce';

function Weather() {
  const api = 'https://api.openweathermap.org/data/2.5/weather';
  const apikey = process.env.REACT_APP_OPENWEATHER_API_KEY;

  const [city, setCity] = useState('New Haven');
  const debouncedCity = useDebounce(city, 500);
  const [weather, setWeather] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    if (debouncedCity) {
      fetchWeather(debouncedCity);
    } else {
      setWeather(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedCity]);

  const fetchWeather = async (selectedCity) => {
    if (!apikey) {
      setWeather(null);
      setError('Missing OpenWeather API key. Restart the React server after adding .env.');
      return;
    }

    try {
      setError('');
      const res = await fetch(`${api}?q=${selectedCity}&appid=${apikey}&units=imperial`);
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || 'Weather request failed');
      setWeather(data);
    } catch (error) {
      console.error('Error fetching weather data:', error);
      setWeather(null);
      setError(error.message);
    }
  };

  return (
    <div>
      <h2>Weather</h2>
      <input
        type="text"
        value={city}
        onChange={(e) => setCity(e.target.value)}
        placeholder="Enter city name"
        style={{ width: '200px', padding: '0.5rem', marginBottom: '1rem' }}
      />
      {!apikey ? (
        <p>Weather demo needs a local API key.</p>
      ) : error ? (
        <p>Weather error: {error}</p>
      ) : weather ? (
        <div>
          <h3>{weather.name}</h3>
          <p>Temperature: {weather.main.temp} F</p>
          <p>Condition: {weather.weather[0].description}</p>
          <p>Humidity: {weather.main.humidity}%</p>
          <p>Wind Speed: {weather.wind.speed} mph</p>
        </div>
      ) : (
        <p>No weather data available. Please enter a city.</p>
      )}
    </div>
  );
}

export default Weather;
